<app-environment-banner></app-environment-banner>
@if (isAccessDeniedRoute()) {
	<router-outlet></router-outlet>
} @else {
	<app-sidenav [class.has-env-banner]="showEnvironmentBanner"></app-sidenav>
}
<app-toast-message></app-toast-message>
